export default "__VITE_ASSET__DveiqZpU__"